var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-container',[_c('div',{staticClass:"page-container"},[_c('div',{staticClass:"map-wrapper"},[_c('AMapLoader',{attrs:{"options":_vm.mapOptions},on:{"init":_vm.handleMapInit,"error":_vm.handleMapError,"on-load":_vm.onLoad}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }